import { render } from "./SummaryClaimComponent.vue?vue&type=template&id=f3a90436&scoped=true"
import script from "./SummaryClaimComponent.vue?vue&type=script&lang=js"
export * from "./SummaryClaimComponent.vue?vue&type=script&lang=js"

import "./SummaryClaimComponent.vue?vue&type=style&index=0&id=f3a90436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3a90436"]])

export default __exports__